import React, {useRef, useEffect} from 'react'
import lottie from 'lottie-web'


const Loader = ({toggle}) => {

    const container = useRef(null)

    useEffect(() => {
        lottie.loadAnimation({
            container : container.current,
            renderer: 'canvas',
            loop: true,
            autoplay: true,
            name:"loaderwardrobe",
            animationData: require('../../assets/Images/data.json')
        })

        if(!toggle) {
            console.log("animation gone")
            lottie.destroy("loaderwardrobe")
        }
        
      return () => {
          console.log("animation longer neede")
          lottie.destroy("loaderwardrobe")
      }
    }, [toggle])
    return (
        <> 
        <div className={`absolute top-0 z-10 inset-0 overflow-y-hidden ${toggle ? 'visible' : 'invisible'}`} aria-labelledby="modal-title" role="dialog" aria-modal="true">
                <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-40 text-center sm:block sm:p-0 mt-20 lg:mt-60">
                    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div className="inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-top md:max-w-sm w-full">
                        <div className="bg-white px-8 pt-5 pb-4 sm:p-6 sm:pb-4">
                           <div className="flex flex-col justify-center items-center space-y-4">
                               <div className="w-60 h-60 bg-white border-white border-4" ref={container}>

                               </div>
                                <h1 className="font-bold text-xl text-center uppercase">
                                    Working some magic
                                </h1>
                           </div>
                                
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Loader